import { PageSupportBlockContainer } from './page-support-block.container';

export default PageSupportBlockContainer;
